'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { type CategoryDTO, type Option } from 'ecosystem'
import useGoogleAnalytics from './use-google-analytics'

export const useTrackPageView = ({ categories }: { categories: Option<CategoryDTO[]> }) => {
  const pathname = usePathname()
  const GA = useGoogleAnalytics({ categories })
  const previousPathRef = useRef<string | null>(null)

  useEffect(() => {
    if (pathname && pathname !== previousPathRef.current) {
      GA.pageView(pathname)
      previousPathRef.current = pathname
    }
  }, [GA, pathname])
}
